import { Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { detailContentPadding } from './detailLayout';

export type DetailDrawerBodyPadding = 'standard' | 'compact' | 'none';

export type DetailDrawerBodyProps = {
  children: ReactNode;
  padding?: DetailDrawerBodyPadding;
  spacing?: number;
};

export function DetailDrawerBody({
  children,
  padding = 'standard',
  spacing,
}: DetailDrawerBodyProps) {
  return (
    <Stack data-slot="body-content" spacing={spacing} sx={{ minWidth: 0, ...(padding === 'standard' ? detailContentPadding : { p: padding === 'compact' ? 1.5 : 0 }) }}>
      {children}
    </Stack>
  );
}
